/* EVENTS */
export const GET_HOLIDAY = "GET_HOLIDAY"
export const GET_HOLIDAY_SUCCESS = "GET_HOLIDAY_SUCCESS"
export const GET_HOLIDAY_FAIL = "GET_HOLIDAY_FAIL"

export const GET_HOLIDAY_DETAILS = "GET_HOLIDAY_DETAILS"
export const GET_HOLIDAY_DETAILS_SUCCESS = "GET_HOLIDAY_DETAILS_SUCCESS"
export const GET_HOLIDAY_DETAILS_FAIL = "GET_HOLIDAY_DETAILS_FAIL"

export const ADD_NEW_HOLIDAY = "ADD_NEW_HOLIDAY"
export const ADD_HOLIDAY_SUCCESS = "ADD_HOLIDAY_SUCCESS"
export const ADD_HOLIDAY_FAIL = "ADD_HOLIDAY_FAIL"

export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY"
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS"
export const UPDATE_HOLIDAY_FAIL = "UPDATE_HOLIDAY_FAIL"

export const DELETE_HOLIDAY = "DELETE_HOLIDAY"
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS"
export const DELETE_HOLIDAY_FAIL = "DELETE_HOLIDAY_FAIL"



export const RESET_HOLIDAY_STATE = 'RESET_HOLIDAY_STATE';
